import { inject, Injectable } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";
import { SaveVirkeskopsKontraktDokumentDTO } from "~app/features/virkeskop/dto/dokument/SaveVirkeskopsKontraktDokumentDTO";
import { VirkeskopDokumentInfoDTO } from "~app/features/virkeskop/dto/dokument/VirkeskopDokumentInfoDTO";
import { ApiClientService } from "../../../common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class KontraktDokumentService {
    private readonly apiClient = inject(ApiClientService);

    getDokumentForKontraktDownload(kontraktId: number, dokumentId: number): Observable<any> {
        const fileUrl = `virkeskop2/${kontraktId}/dokument/${dokumentId}/download`;
        return this.apiClient.getRaw(fileUrl, false,  { responseType: "blob" });
    }

    async getDokumentForKontrakt(kontraktId: number, dokumenttyp: string = null): Promise<VirkeskopDokumentInfoDTO[]> {
        const path = this.generateDokumentTypPath(`virkeskop2/${kontraktId}/dokument`, dokumenttyp);
        return firstValueFrom(this.apiClient.get<VirkeskopDokumentInfoDTO[]>(path));
    }

    async getDokumentForAtgard(atgardId: number, dokumenttyp: string = null): Promise<VirkeskopDokumentInfoDTO[]> {
        const path = this.generateDokumentTypPath(`virkeskop2/atgard/${atgardId}/dokument`, dokumenttyp);
        return firstValueFrom(this.apiClient.get<VirkeskopDokumentInfoDTO[]>(path));
    }

    async uploadDokumentAsync(dokument: SaveVirkeskopsKontraktDokumentDTO): Promise<VirkeskopDokumentInfoDTO[]> {
        return firstValueFrom(this.apiClient.post<SaveVirkeskopsKontraktDokumentDTO, VirkeskopDokumentInfoDTO[]>(`virkeskop2/${dokument.kontraktId}/dokument`, dokument));
    }

    async deleteDokument(kontraktId: number, dokumentId: number): Promise<boolean> {
        return firstValueFrom(this.apiClient.delete(`virkeskop2/${kontraktId}/dokument/${dokumentId}`));
    }

    private generateDokumentTypPath(path: string, dokumenttyp: string) {
        if (dokumenttyp) {
            return `${path}?dokumenttyp=${dokumenttyp}`;
        }
        return `${path}`;
    }
}
